import { AppRoutes } from "../../routes/routes";
export class OperationsViewModel {
    store;
    service;
    name = this.constructor.name;
    constructor(store, service) {
        this.store = store;
        this.service = service;
    }
    // Getter props
    get operations() {
        return this.store.operations;
    }
    get selectedOperation() {
        return this.store.selectedOperation;
    }
    get allOperationsLoaded() {
        return this.store.allEntriesLoaded;
    }
    get canCancelOperation() {
        return this.selectedOperation?.status === "PENDING";
    }
    get hasRegistrationIdFilter() {
        return this.store.registrationId !== "";
    }
    get registrationIdFilter() {
        return this.store.registrationId;
    }
    // Actions
    setSelectedOperation(op) {
        this.store.setSelectedOperation(op);
    }
    // Service calls
    async reloadSelectedOperation() {
        if (this.store.selectedOperation?.operationId) {
            try {
                await this.service.reloadOperation(this.store.selectedOperation?.operationId, true);
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    async getOperations(userId, regId, logOnSuccess = false) {
        try {
            await this.service.getOperationsList(userId, regId, logOnSuccess);
        }
        catch (error) {
            console.error(error);
        }
    }
    // The next page uses registration ID that was once set by clicking the Filter button.
    // This behavior prevents changing registration ID between pagination calls.
    async getNextPage(userId) {
        if (!userId) {
            return;
        }
        await this.service.getNextPage(userId);
    }
    async cancelOperation(op, userId, reason) {
        if (!op) {
            return;
        }
        try {
            await this.service.cancelOperation(op, reason ?? "");
            // reload operation
            await this.service.reloadOperation(op.operationId);
            // also reload operations list
            await this.service.reloadOperationsList(userId);
        }
        catch (error) {
            console.error(error);
        }
    }
    notifyLocationChanged(route, params) {
        if (route === AppRoutes.Operations && params?.userId) {
            // if there are no data, we want to do init call on route change
            if (this.store.registrationId !== params.filterRegId) {
                void this.getOperations(params.userId, params.filterRegId ?? "");
            }
        }
        // Registration Detail
        if (route === AppRoutes.OperationsDetail) {
            // if there is no selected operation, it means user was not in operations list
            // it most probably re-loads the operation detail URL
            if (!this.selectedOperation && params?.uuid) {
                // in that case, we want to fetch operation detail and set it as selected registration
                void this.service.reloadOperation(params.uuid).catch((error) => {
                    console.error(error);
                });
            }
        }
    }
}
